import ModalDialog from '@ui/modal/ModalDialog';
import { checkMobile } from '@utils/functions';
import useBreakpoint from '@utils/useBreakpoint';
import React, { Suspense, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import { getConfig } from './utils/vyking-ar/vyking-ar';
const VtoCamera = React.lazy(() => import('./VtoCamera'));
const VtoModal = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const currentBreakpoint = useBreakpoint();
    const [vykingConfig, setVykingConfig] = useState();
    const enabledCamera = useMemo(() => checkMobile() || window.isVtoEnabled, [currentBreakpoint]);
    const configUri = (_a = props.vtoBin) !== null && _a !== void 0 ? _a : props.basePath + '/modeld.bin';
    // effect to load models.bin after page load
    useEffect(() => {
        if (enabledCamera) {
            setVykingConfig(getConfig(configUri));
        }
    }, [enabledCamera]);
    useEffect(() => {
        if (window.sprChat) {
            if (props.open) {
                window.sprChat && window.sprChat('disable');
            }
            else {
                window.sprChat && window.sprChat('enable');
            }
        }
    }, [props.open]);
    if (!((_b = props === null || props === void 0 ? void 0 : props.product) === null || _b === void 0 ? void 0 : _b.VTOcode)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(ModalDialog, { className: enabledCamera ? 'vto-enabled' : 'vto-modal', overlayClassName: enabledCamera && 'vto-overlay mobile-visible', isOpen: props.open, onRequestClose: props.onClose, noPadding: true, hideHeader: true }, enabledCamera ? (React.createElement(Suspense, { fallback: React.createElement("div", null) },
        React.createElement(VtoCamera, { product: props.product, closeModal: props.onClose, basePath: props.basePath, loadConfig: vykingConfig }))) : (React.createElement(React.Fragment, null,
        React.createElement("img", { src: props.modalImage, alt: "" }),
        React.createElement("div", { className: "vto-modal__detail" },
            React.createElement("h2", { className: "primary-m mb-8" }, t('label.modalvto')),
            React.createElement("p", null, t('label.modalvtodesc')),
            React.createElement("ol", null,
                React.createElement("li", null, t('vto.modal1')),
                React.createElement("li", null, t('vto.modal2')),
                React.createElement("li", null, t('vto.modal3'))),
            React.createElement("div", { className: "qr-code-container" },
                React.createElement(QRCode, { className: "QRCodeImg", value: location.origin + location.pathname + '?openVTO=true' })))))));
};
export default VtoModal;
